import { useState } from 'react'
import {
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  TextInput,
} from 'react-admin'
import { styled } from '@mui/system'

const StyledArrayInput = styled(ArrayInput)`
  margin-bottom: 10px;
  > label {
    color: black;
    font-size: 23px;
    margin-left: -14px;
  }
`

const StyledSimpleFormIterator = styled(SimpleFormIterator)`
  > .RaSimpleFormIterator-line {
    > div {
      display: none;
    }
  }
`

const ScrutateursSelector = ({ optionRenderer }) => {
  return (
    <StyledArrayInput source="scrutateurs">
      <StyledSimpleFormIterator
        inline
        disableReordering
        getItemLabel={() => null}
      >
        <ReferenceInput
          label="Scrutateur"
          source="id"
          reference="ext_coproprietaires"
          style={{ display: 'inline-block', float: 'left', marginRight: '8px' }}
        >
          <SelectInput
            optionText={optionRenderer}
            label="Scrutateur"
            allowEmpty
            fullWidth
            helperText={false}
          />
        </ReferenceInput>
        <TextInput
          label="Scrutateur (email libre)"
          source="email"
          fullWidth
          helperText={false}
        />
      </StyledSimpleFormIterator>
    </StyledArrayInput>
  )
}

export default ScrutateursSelector
